import { useEffect, useState } from 'react'

export default function useGreetings() {

    const [greetings, setGreetings] = useState("")
    
    useEffect(()=>{
        
        const currentDate = new Date()
        const hrs = currentDate.getHours()

        
        if (hrs < 12)
            setGreetings("Good morning");
        else if (hrs >= 12 && hrs <= 17)
            setGreetings("Good afternoon")
        else if (hrs >= 17 && hrs <= 24)
            setGreetings("Good evening")
        else{
            setGreetings("Hello")
        }

    }, [])

    return greetings
}
